export const AccountLogoutWrapper = 'flex w-full flex-col text-black'

export const AccountLogoutCustomerName =
  'capitalize pb-2 text-20 xl:text-24 font-bold font-Lora leading-28 tracking-0'

export const AccountLogoutButton =
  'text-18 font-Roboto font-bold leading-22 tracking-0 items-center flex gap-2 w-full text-left uppercase text-black cursor-pointer hover:underline underline-offset-4'
